var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"title-wrapper"},[_vm._v(" "+_vm._s(_vm.titles[0])+" "),(_vm.client.id)?[(_vm.link)?_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'clientEdit', params: { id: _vm.client.id } }}},[_vm._v(" "+_vm._s(_vm.name)+" ")]):(
        _vm.$route.name === 'review' || 
          _vm.$route.name === 'reviewAssess' ||
          _vm.$route.name === 'reviewSleepLog'
      )?_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")]):_c('span')]:_vm._e(),_vm._v(" "+_vm._s(_vm.titles[1])+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }